import { PLAYER_LICENSE } from './player-license';

export const environment = {
  production: true,
  localDev: false,
  env_name: 'prod',
  accountId: '586224314720',


  castlabs_idp_issuer: 'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_MMywSi1v4',
  castlabs_idp_app_client_id: 'uicu359vtkfgq881c4bci7s7a',
  castlabs_idp_logout_url: 'https://login.castlabs.com/logout?client_id={{client_id}}&logout_uri=\' + window.location.origin + \'/',
  castlabs_idp_api_base: window.location.hostname === 'platform.local'
    ? '/api/v1'
    : 'https://auth.castlabs.com/api/v1',
  castlabs_idp_mfa_setup: 'https://account.castlabs.com/account',

  above_idp_issuer: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_Pk3lI2gyt',
  above_idp_app_client_id: '2joit9qv0serdel87j8fk0gv84',
  // Trades the above id_token for the CS token the backends are called with (ApiTokenService).
  federate_url: 'https://federate.content.castlabs.com/',

  uploaderurl: 'https://up.content.castlabs.com',

  VTK: 'https://fe.vtk.castlabs.com',
  VTK_API: 'https://api.vtk.castlabs.com',
  Portal: 'https://portal.content.castlabs.com',

  region: 'us-east-1',
  graphql: 'https://repository.content.castlabs.com/graphql',
  workflow_graphql: 'https://workflow.content.castlabs.com/graphql',
  status_graphql: 'https://status.content.castlabs.com/graphql',
  signiant_graphql: 'https://rx-signiant.content.castlabs.com/graphql',
  aspera_graphql: 'https://aspera.content.castlabs.com/graphql',
  crd_signal_server: 'https://crd-signal.content.castlabs.com',

  // Shared across all environments -- see ./player-license.ts
  player_license: PLAYER_LICENSE,

  title: 'Castlabs Content Platform',


  poitems_table: 'workflow-prod-POItems-13EL0TLCITA3W',

  redirects : {
    'above_above': 'urn:janus:organization:aa71fb8f45e74abf98ccc0566a21eb23',
    'above_touch': 'urn:janus:organization:a07d57b38a5a46e79b44cf8386e20fec',
    'castlabs': 'urn:janus:organization:d4581b7ed5444a75babdf862ff47b0ba'
  }
};
